
import checkUserInOrganization from './guards/checkUserInOrganization'

const Layout = () => import(/* webpackChunkName: "group-organization" */ './components/ui/layout')

const Dashboard = () => import(/* webpackChunkName: "group-organization" */ './pages/Dashboard')
const Leads = () => import(/* webpackChunkName: "group-organization" */ './pages/Leads')
const Products = () => import(/* webpackChunkName: "group-organization" */ './pages/Products')
const Reviews = () => import(/* webpackChunkName: "group-organization" */ './pages/Reviews')

export default [
  {
    path: '/organizations/:organizationId',
    component: Layout,
    beforeEnter: checkUserInOrganization,
    meta: {
      requiresAuth: true,
    },
    props: true,
    children: [
      {
        path: 'dashboard',
        name: 'OrganizationDashboard',
        component: Dashboard,
        props: true,
        alias: [''],
        meta: {
          title: 'Organization | Dashboard',
        },
      },
      {
        path: 'leads',
        name: 'OrganizationLeads',
        component: Leads,
        props: true,
        meta: {
          title: 'Organization | Leads',
        },
      },
      {
        path: 'products',
        name: 'OrganizationProducts',
        component: Products,
        props: true,
        meta: {
          title: 'Organization | Products',
        },
      },
      {
        path: 'products/:productId',
        name: 'OrganizationProductsEdit',
        component: Products,
        props: true,
        meta: {
          title: 'Organization | Products',
        },
      },
      {
        path: 'reviews',
        name: 'OrganizationReviews',
        component: Reviews,
        props: true,
        meta: {
          title: 'Organization | Reviews',
        },
      },
    ],
  },
]
